"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aristarchus = void 0;
const Tags_1 = require("../../Tags");
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Card_1 = require("../../Card");
class Aristarchus extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.ARISTARCHUS,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.EARTH, Tags_1.Tags.JOVIAN],
            startingMegaCredits: 33,
            metadata: {
                cardNumber: 'R62',
                description: 'You start with 33 M€.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br.br.br.br;
                    b.megacredits(33);
                    b.corpBox('action', (ce) => {
                        ce.vSpace();
                        ce.action('If you have exactly 0 M€, gain 10 M€', (eb) => {
                            eb.empty().startAction.megacredits(10).asterix();
                        });
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        return player.megaCredits === 0;
    }
    action(player) {
        player.megaCredits += 10;
        return undefined;
    }
}
exports.Aristarchus = Aristarchus;
//# sourceMappingURL=Aristarchus.js.map